export const DEFAULT_TITLE = `This brand is not on the brand list for this marketplace. Suggested
native brands:`;
export const ALTERNATIVE_BRAND_LIST_EMPTY = "Not found suggested native brand.";

export const COMMA_SYMBOL = ",";
export const DOT_SYMBOL = ".";
